import Commons from '../../../Services/Common/Common';

export const M_PPE_BASIC_Schema = {
  mapper: {
    /** 보호구 등록 조회 GetPpeBasic01R1 */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
    },
    /** 보호구 자가 체크 여부 저장 SaveEquipLogU1 */
    save1: {
      ErCd: (row) => Commons.EncryptAES(row.erCd ?? '') || '',
      EquipYn: (row) => Commons.EncryptAES(row.equipYn ?? 'N') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
